const BlogLinkCard = ({ title, description, imageUrl, link, target }) => {
  return (
    <div className="grid gap-y-3 sm:gap-y-6">
      <a
        className="group bg-gray-50 border rounded-xl p-3 sm:p-4 hover:bg-gray-100 hover:shadow-sm transition"
        href={link}
        target={target}
      >
        <div className="flex items-center gap-x-5">
          <img
            className="flex-shrink-0 w-full max-w-24 sm:max-w-52 rounded-xl shadow-md"
            src={imageUrl}
            alt={title}
            loading="lazy"
          />
          <div className="grow">
            <h3 className="sm:text-lg font-semibold">
              {title}
            </h3>
            <p className="sm:mt-2 text-sm sm:text-base text-gray-800">
              {description}
            </p>
            <p className="mt-3 inline-flex justify-center items-center gap-x-1 text-sm font-semibold text-blue-500 hover:text-blue-900">
              サイトを開く
              <svg
                className="flex-shrink-0 size-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M7 7h10v10"></path>
                <path d="M7 17 17 7"></path>
              </svg>
            </p>
          </div>
        </div>
      </a>
    </div>
  );
};

export default BlogLinkCard;
